<template>
  <div class="mappables-container">
    <div v-for="mappable in mappables" :key="mappable.id">
      <mappable-list-item :mappable="mappable" :onClick="onClick" />
    </div>
  </div>
</template>

<script>
import MappableListItem from './mappable-list-item';
export default {
  components: {
    MappableListItem,
  },

  props: {
    mappables: Array,
    onClick: Function,
  },
};
</script>

<style lang="scss" scoped>
.mappables-container {
  overflow-y: auto;
  height: 100%;
}
</style>
